import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiClickTriggerForModule } from '../click-trigger-for/click-trigger-for.module';
import { MediaBankFileUploadDetailModule } from '../../media-bank/media-bank-file-upload-detail/media-bank-file-upload-detail.module';
import { FileUploadModel } from './file-upload.model';
import { FiBtnUploadFileModule } from '../../shared/fi-insert-media/btn-upload-file/btn-upload-file.module';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiClickTriggerForModule,
        MediaBankFileUploadDetailModule,
        FiBtnUploadFileModule,
        MatButtonModule,
        FiInsertMediaModule,
    ],
    declarations: [FileUploadComponent],
    exports: [FileUploadComponent],
})
export class FileUploadModule {}
